module.exports = __webpack_public_path__ + "images/vc-colored-d02ca3.svg";